<template>
  <div>
    <loginbox></loginbox>
    <search></search>
    <tablist :title="'出售大厅'" :showbtn="true" :overtype="true" :codeshow="4"></tablist>
  </div>
</template>

<script>
  import loginbox from '@/components/common/loginbox/loginbox'
  import search from '@/components/common/search/search'
  import tablist from '@/components/common/tablist/tablist'
  export default {
    name: 'overhall',
    data () {
      return {
      }
    },
    created () {
      this.scroll()
    },
    activated () {
    },
    mounted () {
    },
    methods: {
      scroll () {
        setTimeout(() => {
          this.$emit('bscroll')
        }, 20)
      }
    },
    // watch : {
    //   '$route.query': function ()
    // },
    components: {
      loginbox,
      search,
      tablist
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/overhall/overhall.vue